module.exports = __webpack_public_path__ + "static/media/e-oops.5c03d70e.png";